/**
 * Schritt 2: Transaktionsdaten importieren
 * Ermöglicht den Import von Transaktionsdaten über die Parqet API und deren Anzeige
 */

import React, { useState } from 'react';
import {
  Container,
  Header,
  Tabs,
  SpaceBetween
} from '@cloudscape-design/components';

import { TransaktionsDaten } from '@/types';
import ImportTab from '@/components/ImportTab';
import TransaktionsdatenTab from '@/components/TransaktionsdatenTab';

interface Schritt2Props {
  transaktionsDaten: TransaktionsDaten[];
  logosByAsset?: Record<string, string>;
  istImportAbgeschlossen: boolean;
  onImport: (
    daten: TransaktionsDaten[],
    currentPricesByAsset?: Record<string, number>,
    logosByAsset?: Record<string, string>,
    soldAssetIdentifiers?: string[]
  ) => void;
  onImportReset?: () => void;
}

/**
 * Hauptkomponente für Schritt 2 mit Tab-Navigation
 */
const Schritt2: React.FC<Schritt2Props> = ({
  transaktionsDaten,
  logosByAsset,
  istImportAbgeschlossen,
  onImport,
  onImportReset
}) => {
  const [activeTabId, setActiveTabId] = useState<string>('import');

  /**
   * Handler für erfolgreichen Import
   */
  const handleImportErfolg = (
    daten: TransaktionsDaten[],
    currentPricesByAsset?: Record<string, number>,
    logosByAssetParam?: Record<string, string>,
    soldAssetIdentifiers?: string[]
  ) => {
    onImport(daten, currentPricesByAsset, logosByAssetParam, soldAssetIdentifiers);
    // Bleibe im aktuellen Tab nach erfolgreichem Import
  };

  /**
   * Tab-Konfiguration mit dynamischer Aktivierung
   */
  const tabs = [
    {
      id: 'import',
      label: 'Import',
      content: (
        <ImportTab
          onImportErfolg={handleImportErfolg}
          istImportAbgeschlossen={istImportAbgeschlossen}
          onImportReset={onImportReset}
        />
      )
    },
    {
      id: 'transaktionsdaten',
      label: istImportAbgeschlossen ? `Transaktionsdaten (${transaktionsDaten.length})` : 'Transaktionsdaten',
      disabled: !istImportAbgeschlossen,
      content: (
        <TransaktionsdatenTab
          transaktionsDaten={transaktionsDaten}
          logosByAsset={logosByAsset}
          istVerfügbar={istImportAbgeschlossen}
        />
      )
    }
  ];

  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Importieren Sie Ihre Transaktionsdaten über die Parqet API und überprüfen Sie die Daten."
        >
          Transaktionsdaten importieren
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        {/* Tab-Navigation */}
        <Tabs
          activeTabId={activeTabId}
          onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
          tabs={tabs}
        />
      </SpaceBetween>
    </Container>
  );
};

export default Schritt2;